﻿import { initNotifications, initSessionExpiryHandling } from './customKendoErrorHandler.js';

$(document).ready(function () {
    initNotifications();
    initSessionExpiryHandling();
});